const CONFIG_CACHE_KEY = 'comphub_auth0_config';
const CONFIG_CACHE_VERSION = '1';

const fetchAuth0ConfigFromBizApi = async () => {
  const response = await fetch('/business/proxy/comphub-product/config/auth0');
  if (!response.ok) {
    throw new Error(`Failed to fetch Auth0 config: ${response.status}`);
  }
  
  const data = await response.json();
  if (data.is_error) {
    throw new Error(data.error?.message || 'Failed to fetch Auth0 config');
  }
  
  return {
    domain: data.domain,
    audience: data.audience,
    clientId: data.clientId,
  };
};

const loadConfigFromCache = () => {
  try {
    const cached = localStorage.getItem(CONFIG_CACHE_KEY);
    if (!cached) return null;
    
    const parsed = JSON.parse(cached);
    if (parsed.version !== CONFIG_CACHE_VERSION) {
      localStorage.removeItem(CONFIG_CACHE_KEY);
      return null;
    }
    
    return parsed.config;
  } catch (error) {
    localStorage.removeItem(CONFIG_CACHE_KEY);
    return null;
  }
};

const saveConfigToCache = (config) => {
  try {
    localStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify({
      version: CONFIG_CACHE_VERSION,
      config: {
        domain: config.domain,
        clientId: config.clientId,
        audience: config.audience,
        authorizationParams: {
          redirect_uri: window.location.origin,
          audience: config.audience,
          scope: 'openid profile email offline_access',
        },
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
      }
    }));
  } catch (error) {
    // Silently handle cache save errors
  }
};

let cachedConfig = null;
let configPromise = null;

export const getAuth0Config = async () => {
  if (cachedConfig) {
    return Promise.resolve(cachedConfig);
  }
  
  const cached = loadConfigFromCache();
  if (cached) {
    cachedConfig = cached;
    Object.assign(auth0Config, cachedConfig);
    return Promise.resolve(cachedConfig);
  }
  
  if (configPromise) {
    return configPromise;
  }
  
  configPromise = fetchAuth0ConfigFromBizApi()
    .then((configData) => {
      if (!configData?.domain || !configData?.audience || !configData?.clientId) {
        throw new Error('Invalid Auth0 config from bizapi');
      }
      
      cachedConfig = {
        domain: configData.domain,
        clientId: configData.clientId,
        audience: configData.audience,
        authorizationParams: {
          redirect_uri: window.location.origin,
          audience: configData.audience,
          scope: 'openid profile email offline_access',
        },
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
      };
      
      saveConfigToCache(cachedConfig);
      Object.assign(auth0Config, cachedConfig);
      
      return cachedConfig;
    })
    .catch((error) => {
      configPromise = null;
      throw error;
    });
  
  return configPromise;
};

export const auth0Config = {
  domain: null,
  clientId: null,
  audience: null,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: null,
    scope: 'openid profile email offline_access',
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
};

const cached = loadConfigFromCache();
if (cached) {
  cachedConfig = cached;
  Object.assign(auth0Config, cached);
}

